import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useDebouncedAction } from "../../../../../../helpers/commonFunction";
import { AppState } from "../../../../../../stateManager/store";
import { onSetFontStylesVisibility, onsetClrPicContext } from "../../../../../../stateManager/store/common/action";
import { getValue, getComponents } from "../../helpers";

import { ColorPicker } from "../ColorPicker";
import { rgbToHex } from "../../../../../marketplace/apps/helpers";
const DEFAULT_BORDER_COLOR: string = "properties.styles.common.borderColor";
const DEFAULT_BORDER_COLOR_V3: string = "properties.styles.$deviceType.borderColor";

type Props = {
  label: string;
  isCheckedIn: boolean;
  defaultValue?: string;
}

export const BorderColor = (props: Props) => {
  const { components } = getComponents()
  const { selectedElementId, deviceType, isCoreV3, computedStyles, wrapperComputedStyles } = useSelector((state: AppState) => state.formJson)
  const { isCheckedIn, defaultValue, label } = props;
  const [oldValue, setOldValue] = useState<string>("");
  const [value, setValue] = useDebouncedAction(defaultValue, 500 || "");
  const component = components[selectedElementId];
  const { colorPickerContext } = useSelector((state: any) => state.common);

  const dispatch=useDispatch()
  const setFontStylesVisibility = (visibility : boolean) =>{
    dispatch(onSetFontStylesVisibility(visibility))
  }
  const setColorPickerVisibility = (visibility: boolean) => {
    dispatch(onsetClrPicContext({ ...colorPickerContext, visibility: visibility }))
  };

  useEffect(() => {
    if (isCoreV3 && component) {
      const previousValue = getValue(component, DEFAULT_BORDER_COLOR_V3.split("."), deviceType);
      if (previousValue) {
        setValue(previousValue)
        setOldValue(previousValue)
      } else if (computedStyles.borderColor) {
        const clr = computedStyles && computedStyles.borderColor
        const rgbaValues = clr?.match(/\d+/g).map(Number) || [];
        let hexColor;
        if (rgbaValues.length === 4) {
          hexColor = rgbToHex(rgbaValues[0], rgbaValues[1], rgbaValues[2], rgbaValues[3]);
        } else if (rgbaValues.length === 3) {
          hexColor = rgbToHex(rgbaValues[0], rgbaValues[1], rgbaValues[2]);
        } else {
          hexColor = null;
        }
        const borderColor: any = (computedStyles && computedStyles.borderColor ? hexColor : null);
        setValue(borderColor)
        setOldValue(borderColor)
      } else {
        const wrapperStyles = wrapperComputedStyles.hasOwnProperty("borderColor") ? wrapperComputedStyles : computedStyles;
        const clr = wrapperStyles && wrapperStyles.borderColor
        const rgbValues = clr?.match(/\d+/g).map(Number) || [];
        const hexColor = rgbToHex(rgbValues[0], rgbValues[1], rgbValues[2]);
        const borderColor: any = (wrapperStyles && wrapperStyles.borderColor ? hexColor : null);
        setValue(borderColor)
        setOldValue(borderColor)
      }
    } else if (!isCoreV3 && component) {
      const previousValue = getValue(component, DEFAULT_BORDER_COLOR.split("."), deviceType);
      if (previousValue) {
        setValue(previousValue)
        setOldValue(previousValue)
      }
    }
    // eslint-disable-next-line
  }, [isCoreV3, component, deviceType, computedStyles]);

  return (
    <ColorPicker
      pickerkey="borderColor"
      label="Border Color"
      value={value}
      open={() => {
      setFontStylesVisibility(false)
      dispatch(onsetClrPicContext({
        value:value,
        placeholder: "",
        where: isCoreV3 ? DEFAULT_BORDER_COLOR_V3 : DEFAULT_BORDER_COLOR,
        visibility:true,
      }))
    }}
    visibility={colorPickerContext?.visibility}
    close={()=>setColorPickerVisibility(false)}
    />
  )
};
